"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CopyToClipboard_1 = __importDefault(require("@/components/interactions/CopyToClipboard"));
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const CustomToolTip_1 = __importDefault(require("../interactions/CustomToolTip"));
const AccountIdBox = ({ id, label, path, isNotLink, maxWidth, tooltip }) => {
    return (react_1.default.createElement(AccountIdContainer, { maxWidth: maxWidth },
        !isNotLink && (react_1.default.createElement(NavLinkStyle, null,
            react_1.default.createElement(react_router_dom_1.Link, { style: { color: 'inherit' }, to: `${path}/${id}` },
                react_1.default.createElement(InnerBox, { sx: { fontFamily: 'Roboto, mono !important', wordBreak: label ? '' : 'break-all' } }, label ? label : id)))),
        isNotLink && (react_1.default.createElement(InnerBox, { sx: { fontFamily: 'Roboto, mono !important', wordBreak: label ? '' : 'break-all' } }, label ? label : id)),
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            tooltip && react_1.default.createElement(CustomToolTip_1.default, { description: tooltip }),
            react_1.default.createElement(CopyToClipboard_1.default, { text: id }))));
};
exports.default = AccountIdBox;
const InnerBox = (0, styled_components_1.default)(material_1.Box) `
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const AccountIdContainer = (0, styled_components_1.default)(material_1.Box) `
  padding: 4px 0;
  color: ${(props) => props.theme.colors.onBg};
  display: flex;
  align-items: center;
  max-width: 650px;
  min-width: 20px;
  ${(props) => props.theme.media.lg} {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '500px')};
  }
  ${(props) => props.theme.media.md} {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '300px')};
  }
  ${(props) => props.theme.media.sm} {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '200px')};
  }
  ${(props) => props.theme.media.xs} {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100px')};
  }
`;
// padding: 10px 10px 10px 20px;
// font-familly: 'Roboto', mono;
const NavLinkStyle = (0, styled_components_1.default)(material_1.Box) `
  width: calc(100% - 40px);
  text-decoration: none;
  color: ${(props) => props.theme.colors.onBg} !important;
  font-size: 1em;
  &:hover {
    color: ${(props) => props.theme.colors.onContrastBg};
    text-decoration: underline;
  }
`;
